import _ from 'lodash';
import async from 'async';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';

import BulkDeliveryContainer from '../../containers/logistics/BulkDelivery';
import BulkDeliveryBatchContainer from '../../containers/logistics/BulkDeliveryBatch';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import SuppliersContainer from '../../containers/logistics/Suppliers';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import FMPTextField from '../../components/ui/FMPTextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import ConfirmBulkDeliveryBatchDialog from '../../components/Dialogs/ConfirmBulkDeliveryBatchDialog';
//import Contacts from '../../components/form/Contacts';

import { terminalProducts } from '../../libs/products';

//import Switch from '@material-ui/core/Switch';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 2,
			marginBottom: 5,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
	};
};
const formFields = {
	productType: 'etoh',
	pickupTerminalId: '',
	pickupSupplierId: '',
	deliveryTerminalId: '',
	deliveryBulkCustomerId: '',
	offloadNumber: '',
	carrierId: '',
	deliveries: [
		{
			loadCount: '',
			deliveryDate: '',
			loadingNumber: '',
		},
	],
	note: '',
};

// XXX Update does not work

class AddBulkDeliveryBatch extends Component {
	constructor(props) {
		super(props);
		const bulkDeliveryId = _.get(this.props, ['match', 'params', 'bulkDeliveryId']);

		this.state = {
			bulkDeliveryId: bulkDeliveryId ? parseInt(bulkDeliveryId, 10) : undefined,
			isUpdate: bulkDeliveryId,
			formFieldError: {},
			isConfirmDialogOpen: false,
			confirmingBulkDeliveryBatch: undefined,
			confirmingResult: undefined,
		};
		this.state = _.merge(this.state, formFields);
		this.state.deliveries = [];
	}

	componentDidMount() {
		const {
			bulkDelivery,
			getBulkDelivery,
			carriers,
			searchCarriers,
			terminals,
			searchTerminals,
			suppliers,
			searchSuppliers,
			bulkCustomers,
			searchBulkCustomers,
		} = this.props;

		const { isUpdate, bulkDeliveryId } = this.state;

		if (!carriers.length) {
			searchCarriers();
		}
		if (!terminals.length) {
			searchTerminals();
		}
		if (!suppliers.length) {
			searchSuppliers();
		}
		if (!bulkCustomers.length) {
			searchBulkCustomers();
		}

		if (!isUpdate) {
			return;
		}

		if (!bulkDelivery) {
			getBulkDelivery({
				params: { bulkDeliveryIds: [bulkDeliveryId] },
			});
		} else {
			const newState = this.getFormValuesFromBulkDelivery({ bulkDelivery });
			this.setState(newState);
		}
	}

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		const prevBulkDelivery = prevProps.bulkDelivery;
		const thisBulkDelivery = this.props.bulkDelivery;

		if (!prevBulkDelivery && thisBulkDelivery) {
			return;
		}
		const newState = this.getFormValuesFromBulkDelivery({ thisBulkDelivery });
		this.setState(newState);
	}

	getFormValuesFromBulkDelivery = (props) => {
		const { bulkDelivery } = props;
		if (!bulkDelivery) {
			return;
		}

		const formValues = {};
		[
			'pickupTerminalId',
			'pickupSupplierId',
			'deliveryTerminalId',
			'deliveryBulkCustomerId',
			'carrierId',
			'note',
		].forEach((key) => {
			if (_.isNil(bulkDelivery[key])) {
				return;
			}
			formValues[key] = bulkDelivery[key];
		});

		const { deliveries } = bulkDelivery;
		formValues.deliveries = [];

		if (!_.isEmpty(deliveries)) {
			deliveries.forEach((delivery) => {
				const { loadCount, deliveryDate } = delivery;
				formValues.deliveries.push({
					loadCount,
					deliveryDate,
				});
			});
		}

		return formValues;
	};

	addInput = (arrayName) => {
		const val = _.cloneDeep(formFields[arrayName]);

		if (arrayName === 'deliveries') {
			const selectedBulkSupplier = this.getSelectedBulkSupplier();

			if (selectedBulkSupplier) {
				if (selectedBulkSupplier.requireLoadingNumbersFromSupplier) {
					val[0].requireLoadingNumbersFromSupplier = true;
				} else if (selectedBulkSupplier.loadingNumber) {
					val[0].loadingNumber = selectedBulkSupplier.loadingNumber;
				}
			}

			// Copy delivery date from the last delivery if it exists
			const currentDeliveries = this.state.deliveries;
			if (currentDeliveries.length > 0) {
				const lastDelivery = currentDeliveries[currentDeliveries.length - 1];
				if (lastDelivery.deliveryDate) {
					val[0].deliveryDate = lastDelivery.deliveryDate;
				}
			}
		}

		this.setState({ [arrayName]: this.state[arrayName].concat(val) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	onChange(event, fieldName, index, attr) {
		const newState = {};
		if (!_.isNumber(index)) {
			newState[fieldName] = event.target.value;
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			newState[fieldName] = inputs;
		}

		if (fieldName === 'deliveryTerminalId') {
			newState.offloadNumber = this.getOffloadNumber({
				selectedTerminalId: newState[fieldName],
			});
		}

		this.setState(newState);
	}

	getOffloadNumber({ selectedTerminalId }) {
		const { deliveryBulkCustomerId, productType } = this.state;

		let offloadNumber = '';
		if (!deliveryBulkCustomerId || !productType) {
			return offloadNumber;
		}

		const { bulkCustomers } = this.props;
		const bulkCustomer = _.find(bulkCustomers, { bulkCustomerId: deliveryBulkCustomerId });
		if (!bulkCustomer) {
			return offloadNumber;
		}

		if (_.isEmpty(bulkCustomer.offloadTerminals)) {
			return offloadNumber;
		}

		bulkCustomer.offloadTerminals.forEach((offloadTerminal) => {
			if (
				offloadTerminal.terminalId === selectedTerminalId &&
				offloadTerminal.productType === productType
			) {
				offloadNumber = offloadTerminal.offloadNumber;
			}
		});
		return offloadNumber;
	}

	onDateTimeChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	closeConfirmDialog = () => {
		this.setState({ isConfirmDialogOpen: false });
	};

	handleSave = () => {
		const { addBulkDeliveryBatch, updateBulkDelivery, showErrors } = this.props;

		//- Required fields
		const formFieldError = {};
		[
			{ fieldName: 'productType', display: 'Product Type' },
			{ fieldName: 'pickupTerminalId', display: 'Pickup Terminal' },
			{ fieldName: 'pickupSupplierId', display: 'Pickup Supplier' },
			{ fieldName: 'deliveryTerminalId', display: 'Delivery Terminal' },
			{ fieldName: 'deliveryBulkCustomerId', display: 'Bulk Customer' },
			{ fieldName: 'carrierId', display: 'Carrier' },
		].forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});

		//- Get all the values and do individual checks
		const {
			productType,
			pickupTerminalId,
			pickupSupplierId,
			deliveryTerminalId,
			deliveryBulkCustomerId,
			offloadNumber,
			carrierId,
			note,
			isUpdate,
			bulkDeliveryId,
		} = this.state;

		const deliveries = _.cloneDeep(this.state.deliveries);

		if (_.isEmpty(deliveries)) {
			formFieldError.deliveries = 'One delivery required';
		}

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		//- Lock and load
		const params = {
			productType,
			pickupTerminalId,
			pickupSupplierId,
			deliveryTerminalId,
			deliveryBulkCustomerId,
			offloadNumber,
			carrierId,
			deliveries,
			note,
		};

		if (!isUpdate) {
			async.waterfall(
				[
					(callback) => {
						addBulkDeliveryBatch({
							params,
							callback,
						});
					},
					(r, callback) => {
						const bulkDeliveryBatch = _.get(r, ['collections', 'bulkDeliveryBatchCollection', 0]);

						if (!bulkDeliveryBatch) {
							return callback('Fatal error. Missing bulkDeliveryBatch.');
						}

						this.showConfirmationPopup({
							bulkDeliveryBatch,
							callback,
						});
					},
				],
				(e) => {
					if (e) {
						showErrors([e]);
					}
				}
			);
		} else {
			params.bulkDeliveryId = bulkDeliveryId;
			updateBulkDelivery({ params });
		}
	};

	showConfirmationPopup = ({ bulkDeliveryBatch, callback }) => {
		const { getNextEmailForBulkDeliveryBatch } = this.props;
		const { bulkDeliveryBatchId } = bulkDeliveryBatch;

		async.waterfall(
			[
				(callback) => {
					getNextEmailForBulkDeliveryBatch({
						params: {
							bulkDeliveryBatchId,
						},
						callback,
					});
				},
				(confirmingResult, callback) => {
					if (!confirmingResult) {
						return callback('Did not get a response from get next email.');
					}

					this.setState({
						isConfirmDialogOpen: true,
						confirmingBulkDeliveryBatch: bulkDeliveryBatch,
						confirmingResult,
					});
					return callback();
				},
			],
			callback
		);
	};

	render() {
		const {
			classes,
			bulkDelivery,
			activateBulkDeliveryBatch,
			carriers,
			terminals,
			showErrors,
		} = this.props;

		const {
			isUpdate,
			bulkDeliveryId,
			pickupTerminalId,
			pickupSupplierId,
			deliveryTerminalId,
			deliveryBulkCustomerId,
			carrierId,
			productType,
			//formFieldError,
			isConfirmDialogOpen,
			confirmingBulkDeliveryBatch,
			confirmingResult,
		} = this.state;

		if (!terminals.length || !carriers.length) {
			return <div>Fetching information...</div>;
		}

		if (isUpdate && !bulkDelivery) {
			return <div>Bulk customer information...</div>;
		}
		const verb = isUpdate ? 'Update' : 'Add';

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{verb} Bulk Delivery {isUpdate && bulkDeliveryId}
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Fuel Pickup</div>

						{this.renderProductSelect({
							label: 'Fuel Type',
							productType,
							name: 'productType',
						})}

						{this.renderTerminalSelectForPickup({
							label: 'Pickup Terminal',
							terminalId: pickupTerminalId,
							name: 'pickupTerminalId',
						})}

						{this.renderSupplierSelect({
							label: 'Pickup Supplier',
							terminalId: pickupTerminalId,
							supplierId: pickupSupplierId,
							name: 'pickupSupplierId',
						})}

						<div className={classes.sectionHeader}>Fuel Offload</div>

						{this.renderBulkCustomerSelect({
							label: 'Bulk Customer',
							bulkCustomerId: deliveryBulkCustomerId,
							name: 'deliveryBulkCustomerId',
						})}

						{this.renderTerminalSelectForDelivery({
							label: 'Delivery Terminal',
							terminalId: deliveryTerminalId,
							name: 'deliveryTerminalId',
						})}

						<FMPTextField
							name={'offloadNumber'}
							label={'Offload Number'}
							controller={this}
							contained={true}
						/>
						<div className={classes.sectionHeader}>Carrier</div>

						{this.renderCarrierSelect({
							label: 'Carrier',
							carrierId: carrierId,
							name: 'carrierId',
						})}

						<div className={classes.sectionHeader}>Delivery Schedule</div>
						{this.renderDeliverySchedule()}

						<div className={classes.sectionHeader}>Note</div>
						<FMPTextField name={'note'} label={'Note'} controller={this} />

						<div style={{ textAlign: 'right' }}>
							<Button
								variant="contained"
								color="primary"
								className={classes.submitButton}
								onClick={this.handleSave}
							>
								{verb} Bulk Delivery
							</Button>
						</div>

						<ConfirmBulkDeliveryBatchDialog
							open={isConfirmDialogOpen}
							onClose={this.closeConfirmDialog}
							activateBulkDeliveryBatch={activateBulkDeliveryBatch}
							bulkDeliveryBatch={confirmingBulkDeliveryBatch}
							confirmingResult={confirmingResult}
							showErrors={showErrors}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	renderDeliverySchedule() {
		const { classes } = this.props;

		const { deliveries, pickupSupplierId } = this.state;

		return (
			<div>
				{deliveries.map((delivery, i) => {
					/*
				const makeOnChange = (index, name) => {
					return (e) => {
						this.onChange(e, 'deliveries', index, name);
					};
				};
				*/

					let loadingHelpText;
					if (delivery.requireLoadingNumbersFromSupplier) {
						loadingHelpText = 'Supplier will provide (if empty)';
					}

					const path = `deliveries.${i}.deliveryDate`;

					return (
						<Grid key={i} container spacing={3} className={classes.inputGroup}>
							<Grid item xs={12} md={4} style={{ marginTop: -15, padding: '2px 10px' }}>
								<FMPDatePicker
									label="Delivery Date"
									path={path}
									onChange={this.onDateTimeChange}
									value={this.getValue(path)}
									error={this.getError(path)}
								/>
							</Grid>

							<Grid item xs={12} md={4} style={{ padding: '2px 10px' }}>
								<FMPTextField
									label={'Loading Number'}
									name={'deliveries'}
									attr={'loadingNumber'}
									index={i}
									controller={this}
									md={12}
									helpText={loadingHelpText}
								/>
							</Grid>

							<Grid item xs={12} md={1}>
								{this.state.deliveries.length >= 2 && (
									<IconButton
										color="primary"
										aria-label="Delete"
										onClick={() => this.removeInput('deliveries', i)}
									>
										<DeleteIcon />
									</IconButton>
								)}
							</Grid>
						</Grid>
					);
				})}

				<Grid container spacing={3}>
					<Grid item xs={12} md={6}>
						<Button
							variant="contained"
							className={classes.addInputButton}
							onClick={() => this.addInput('deliveries')}
							disabled={!pickupSupplierId}
						>
							{!deliveries.length && 'ADD A DELIVERY'}
							{!!deliveries.length && 'ADD ANOTHER DELIVERY'}
						</Button>
						{!pickupSupplierId ? (
							<div style={{ fontSize: 12, color: '#999' }}>Pick a supplier first</div>
						) : null}
					</Grid>
				</Grid>
			</div>
		);
	}

	renderProductSelect({ productType, name, label }) {
		//const { terminals } = this.props;

		const id = `ts_${name}`;
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={6}>
					<FormControl fullWidth={true}>
						<InputLabel htmlFor={id}>{label}</InputLabel>
						<Select
							value={productType}
							onChange={(e) => this.onChange(e, name)}
							input={<Input name={id} id={id} />}
						>
							{terminalProducts.map((item) => {
								if (item.value !== 'etoh') {
									return null;
								}

								return (
									<MenuItem key={item.value} value={item.value}>
										{item.display}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	renderTerminalSelectForPickup({ terminalId, name, label }) {
		const terminals = this.getTerminalsForProduct();

		const id = `ts_${name}`;
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={6}>
					<FormControl fullWidth={true}>
						<InputLabel htmlFor={id}>{label}</InputLabel>
						<Select
							value={terminalId}
							onChange={(e) => this.onChange(e, name)}
							input={<Input name={id} id={id} />}
						>
							{terminals.map((item) => {
								return (
									<MenuItem key={item.terminalId} value={item.terminalId}>
										{item.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	renderTerminalSelectForDelivery({ terminalId, name, label }) {
		const { terminals = [], warning } = this.getTerminalsForBulkCustomer();

		let disabled = false;
		let helperText = '';
		if (warning) {
			disabled = true;
			helperText = warning;
		}

		const id = `ts_${name}`;
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={6}>
					<FormControl fullWidth={true} disabled={disabled}>
						<InputLabel htmlFor={id}>{label}</InputLabel>
						<Select
							value={terminalId}
							onChange={(e) => this.onChange(e, name)}
							input={<Input name={id} id={id} />}
						>
							{terminals.map((item, index) => {
								if (!item) {
									return (
										<MenuItem key={index} value={undefined}>
											Item is undefined
										</MenuItem>
									);
								}

								return (
									<MenuItem key={item.terminalId} value={item.terminalId}>
										{item.name}
									</MenuItem>
								);
							})}
						</Select>
						{!!helperText && <FormHelperText>{helperText}</FormHelperText>}
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	renderSupplierSelect({ supplierId, terminalId, name, label }) {
		const suppliersForProduct = this.getSuppliersForTerminalProduct({ terminalId });

		let disabled = false;
		let helperText = '';
		if (!terminalId) {
			disabled = true;
			helperText = 'Pick a terminal first';
		}

		const selectedBulkSupplier = this.getSelectedBulkSupplier();
		if (selectedBulkSupplier) {
			if (selectedBulkSupplier.requireLoadingNumbersFromSupplier) {
				helperText = 'Supplier will provide loading numbers';
			} else if (selectedBulkSupplier.loadingNumber) {
				helperText = `Will use loading number ${selectedBulkSupplier.loadingNumber}`;
			} else {
				helperText = '⚠️ Supplier missing loading numbers';
			}
		}

		const id = `ts_${name}`;
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={6}>
					<FormControl fullWidth={true} disabled={disabled}>
						<InputLabel htmlFor={id}>{label}</InputLabel>
						<Select
							value={supplierId}
							onChange={(e) => this.onChange(e, name)}
							input={<Input name={id} id={id} />}
						>
							{suppliersForProduct.map((item) => {
								return (
									<MenuItem key={item.supplierId} value={item.supplierId}>
										{item.name}
									</MenuItem>
								);
							})}
						</Select>
						<FormHelperText>{helperText}</FormHelperText>
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	renderBulkCustomerSelect({ bulkCustomerId, name, label }) {
		const { bulkCustomers } = this.props;

		const id = `ts_${name}`;
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={6}>
					<FormControl fullWidth={true}>
						<InputLabel htmlFor={id}>{label}</InputLabel>
						<Select
							value={bulkCustomerId}
							onChange={(e) => this.onChange(e, name)}
							input={<Input name={id} id={id} />}
						>
							{bulkCustomers.map((item) => {
								return (
									<MenuItem key={item.bulkCustomerId} value={item.bulkCustomerId}>
										{item.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	renderCarrierSelect({ carrierId, name, label }) {
		const { carriers } = this.props;

		const id = `ts_${name}`;
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={6}>
					<FormControl fullWidth={true}>
						<InputLabel htmlFor={id}>{label}</InputLabel>
						<Select
							value={carrierId}
							onChange={(e) => this.onChange(e, name)}
							input={<Input name={id} id={id} />}
						>
							{carriers.map((item) => {
								return (
									<MenuItem key={item.carrierId} value={item.carrierId}>
										{item.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	getTerminalsForProduct() {
		const { productType } = this.state;
		const { terminals } = this.props;

		const terminalsById = {};
		terminals.forEach((terminal) => {
			if (_.isEmpty(terminal.bulkSuppliers)) {
				return;
			}

			terminal.bulkSuppliers.forEach((bulkSupplier) => {
				if (bulkSupplier.product === productType) {
					terminalsById[terminal.terminalId] = terminal;
				}
			});
		});
		return _.values(terminalsById);
	}

	getTerminalsForBulkCustomer() {
		const { deliveryBulkCustomerId, productType } = this.state;

		if (!deliveryBulkCustomerId || !productType) {
			return {
				warning: 'Pick a bulk customer and a product type first',
			};
		}

		const { terminals, bulkCustomers } = this.props;
		const terminalMap = _.keyBy(terminals, 'terminalId');
		const bulkCustomer = _.find(bulkCustomers, { bulkCustomerId: deliveryBulkCustomerId });

		if (!bulkCustomer) {
			return {
				warning: 'Could not find bulk customer',
			};
		}

		if (_.isEmpty(bulkCustomer.offloadTerminals)) {
			return {
				warning: 'Bulk customer does not have any valid offload terminals.',
			};
		}

		const retTerminals = [];
		bulkCustomer.offloadTerminals.forEach((offloadTerminal) => {
			if (offloadTerminal.productType === productType) {
				retTerminals.push(terminalMap[offloadTerminal.terminalId]);
			}
		});
		return {
			terminals: retTerminals,
		};
	}

	getSelectedBulkSupplier() {
		const { terminals } = this.props;
		const { pickupTerminalId, pickupSupplierId, productType } = this.state;
		if (!productType || !pickupTerminalId || !pickupSupplierId) {
			return null;
		}

		let selectedBulkSupplier = undefined;
		terminals.forEach((terminal) => {
			if (_.isEmpty(terminal.bulkSuppliers)) {
				return;
			}
			if (pickupTerminalId !== terminal.terminalId) {
				return;
			}

			terminal.bulkSuppliers.forEach((bulkSupplier) => {
				if (bulkSupplier.product !== productType) {
					return;
				}
				if (bulkSupplier.supplierId !== pickupSupplierId) {
					return;
				}
				selectedBulkSupplier = bulkSupplier;
			});
		});
		return selectedBulkSupplier;
	}

	getSuppliersForTerminalProduct({ terminalId }) {
		const { productType } = this.state;
		const { terminals, suppliers } = this.props;
		const suppliersById = {};

		const supplierMap = _.keyBy(suppliers, 'supplierId');

		terminals.forEach((terminal) => {
			if (_.isEmpty(terminal.bulkSuppliers)) {
				return;
			}

			if (terminalId !== terminal.terminalId) {
				return;
			}

			terminal.bulkSuppliers.forEach((bulkSupplier) => {
				if (bulkSupplier.product === productType) {
					const id = bulkSupplier.supplierId;
					suppliersById[id] = supplierMap[id];
				}
			});
		});
		return _.values(suppliersById);
	}
}

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

AddBulkDeliveryBatch.propTypes = {
	//- For update
	getBulkDelivery: PropTypes.func.isRequired,
	bulkDelivery: PropTypes.object,
	updateBulkDelivery: PropTypes.func.isRequired,

	//- Add
	addBulkDeliveryBatch: PropTypes.func.isRequired,
	activateBulkDeliveryBatch: PropTypes.func.isRequired,
	getNextEmailForBulkDeliveryBatch: PropTypes.func.isRequired,

	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,

	searchSuppliers: PropTypes.func.isRequired,
	suppliers: PropTypes.array,

	searchBulkCustomers: PropTypes.func.isRequired,
	bulkCustomers: PropTypes.array,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	BulkDeliveryContainer,
	BulkDeliveryBatchContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	SuppliersContainer,
	BulkCustomersContainer,
])(AddBulkDeliveryBatch);
